import { render, staticRenderFns } from "./FormSchemaBuilder.vue?vue&type=template&id=5feb4d92&"
import script from "./FormSchemaBuilder.vue?vue&type=script&lang=js&"
export * from "./FormSchemaBuilder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../Projects/register/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports